import { CallAPIPromise } from "../billing/common";
import { setAlertWithTitle, setSpinnerLoading } from "../utility/Redux/modal";
import Store from "../utility/Redux/store";
import FirstIcodeItem from "./icodeEnterValue";
import uniqeid from "uniqid";

export const emptyRowDetails = {
  id: uniqeid(),
  VOUCHER_PRINT_PREFIX: "VCH",
  DOC_NO: "DOC123",
  VOUCHER_TYPE: "Payment",
  DATE: "2025-04-02",
  NARRATION: "Payment for office supplies",
  ENTRY_LINK: "12345",
  ACCOUNT_NO: "",
  ACCOUNT_NAME: "",
  UNDER_GROUP_CODE: "UG001",
  UNDER_GROUP: "Expenses",
  ROOT_GROUP: "Liabilities",
  BALANCE_SHEET_CLASS: "Asset",
  BALANCE_SHEET_SIDE: "Debit",
  DEBIT: 0,
  CREDIT: 0,
  TRANSACTION_TYPE: "",
  REMARKS: "",
  LEDGER_NAME: "",
  BANK_NAME: "",
  FAVOURING_NAME: "",
  FAVOURING_CODE: "0",
  ENTRY_LINK: "",
  CLEARANCE_DATE: "",
  INSTRUMENT_NUMBER: "",
  INSTRUMENT_DATE: "",
  TYPE_OF_TRANSACTION: "",
  SALE_BILL_NO: "",
  SALE_ENTRY_CODE: "",
  PURCHASE_BILL_NO: "",
  PURCHASE_ENTRY_CODE: "",
  MOBILE: "",
};

export const emtyRowDetailSAccountLedger = {
  id: uniqeid(),
  ACCOUNT_NO: "",
  TAX_ACCOUNT_NO: "",
  TAX_ACCOUNT_NAME: "",
  PERCENTAGE: "",
};

export function enterRowWithAccountDetails(
  filteredItems,
  rows,
  id,
  dispatch,
  setRows,
  value,
  setAlertTwoButtonModal,
  setItemMasterStatus,
  partyDetails
) {
  const prefix = Store.getState().profile.prefix;

  if (filteredItems[0]) {
    if (!filteredItems[0].UNDER_GROUP_CODE) {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Under group is not defined in account master. Please update account master",
        })
      );
      return;
    }
    if (!rows.find((r) => r.ACCOUNT_NO === filteredItems[0].ACCOUNT_NO)) {
      CallAPIPromise("/api/Accounts/calculate_row_wise_account_balance", {
        table_prefix: prefix,
        ACCOUNT_NO: filteredItems[0].ACCOUNT_NO,
      }).then((res) => {
        if (res.status === 200) {
          const calculationData = res.data;
          const isSameIdExist = rows.filter((row) => row.id === id);

          if (isSameIdExist[0]) {
            setRows((old) => {
              const list = old.map((item) => {
                if (item.id === id) {
                  const i = FirstIcodeItem(id, partyDetails, {
                    ...filteredItems[0],
                    CURRENT_BALANCE: calculationData.CURRENT_BALANCE,
                    CURRENT_BALANCE2: calculationData.CURRENT_BALANCE,
                    CURRENT_BALANCE_TYPE: calculationData.CURRENT_BALANCE_TYPE,
                  });

                  return i;
                } else {
                  return item;
                }
              });
              const isEmptyRow = list.filter((r) => r.ACCOUNT_NAME === "");
              if (isEmptyRow[0]) {
                return [...list];
              } else {
                return [
                  ...list,
                  {
                    ...emptyRowDetails,
                    id: uniqeid(),
                  },
                ];
              }
            });
          } else {
            setRows((old) => {
              const i = FirstIcodeItem(uniqeid(), partyDetails, {
                ...filteredItems[0],
                OPENING_BALANCE_TYPE: calculationData.OPENING_BALANCE_TYPE,
                OPENING_BALANCE: calculationData.OPENING_BALANCE,
              });
              return [
                ...old,
                {
                  ...i,
                },
                {
                  ...emptyRowDetails,
                  id: uniqeid(),
                },
              ];
            });
          }
          dispatch(setSpinnerLoading(false));
        }
      });
    } else {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Account already exist",
        })
      );
    }

    // }
  } else {
    setAlertTwoButtonModal({
      status: true,
      title: "Not Found",
      msg: "Account Not Found",
      // button1: "Yes",
      // button1Click: () => {
      //   dispatch(setSpinnerLoading(false));
      //   // const nearestInput = document.getElementById(
      //   //   id + "-" +'ICODE'
      //   // );
      //   // if (nearestInput) {
      //   //   nearestInput.focus();
      //   //   nearestInput.select();
      //   // }
      //   // setItemMasterStatus(true);
      //   setAlertTwoButtonModal({ status: false });
      // },
      button1: "Ok",
      button1Click: () => {
        const nearestInput = document.getElementById(id + "-" + "ACC_");
        if (nearestInput) {
          nearestInput.focus();
          nearestInput.select();
        }
        dispatch(setSpinnerLoading(false));
        setAlertTwoButtonModal({ status: false });
      },
    });
  }
}

export const FirstIcodeItem2 = (id, item) => {
  return {
    id: id,
    // ACCOUNT_NO: "",
    TAX_ACCOUNT_NAME: item.TAX_ACCOUNT_NAME ? item.TAX_ACCOUNT_NAME : "",
    PERCENTAGE: item?.PERCENTAGE ? item?.PERCENTAGE : "",
    TAX_ACCOUNT_NO: item.TAX_ACCOUNT_NO,
  };
};
export function enterRowWithAccountDetails2(
  filteredItems,
  accountLedgerRows,
  id,
  dispatch,
  setAccountLedgerRows,
  value,
  setAlertTwoButtonModal,
  setItemMasterStatus
) {
  if (filteredItems[0]) {
    const isSameIdExist = accountLedgerRows.filter((row) => row.id === id);

    if (isSameIdExist[0]) {
      setAccountLedgerRows((old) => {
        const list = old.map((item) => {
          if (item.id === id) {
            const i = FirstIcodeItem2(id, filteredItems[0]);

            return i;
          } else {
            return item;
          }
        });
        const isEmptyRow = list.filter((r) => r.TAX_ACCOUNT_NAME === "");
        if (isEmptyRow[0]) {
          return [...list];
        } else {
          return [
            ...list,
            {
              ...emtyRowDetailSAccountLedger,
              id: uniqeid(),
            },
          ];
        }
      });
    } else {
      setAccountLedgerRows((old) => {
        const i = FirstIcodeItem2(uniqeid(), filteredItems[0]);
        return [
          ...old,
          {
            ...i,
          },
          {
            ...emtyRowDetailSAccountLedger,
            id: uniqeid(),
          },
        ];
      });
    }
    dispatch(setSpinnerLoading(false));
    // }
  } else {
    dispatch(
      setAlertWithTitle({
        title: "Not Found",
        msg: "Account not found releated this account number.",
      })
    );
  }
}
